import React from "react";
import { CalendarDays, MapPin, Printer, ArrowRight, ScanLine } from "lucide-react";
import { Card, Btn } from "../UI";
import { usd, pct, valueLabel, dateRange } from "./format";

const Stat = ({ label, value, accent }) => (
  <span className="text-xs text-slate-300">{label} <b className={accent ? "text-amber-300" : ""}>{value}</b></span>
);

export const EventCard = ({ ev, onOpen }) => {
  const s = ev.stats || {};
  return (
    <Card className="!p-4" data-testid={`event-card-${ev.id}`}>
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-display font-bold text-sm">{ev.name}</span>
            {ev.promotion && (
              <span className="text-[10px] px-2 py-0.5 rounded-full border border-amber-400/30 bg-amber-400/10 text-amber-300">
                {ev.promotion.name} · {valueLabel(ev.promotion)}
              </span>
            )}
            {!ev.active && <span className="text-[10px] px-2 py-0.5 rounded-full border border-rose-400/25 bg-rose-400/5 text-rose-300">Archived</span>}
          </div>
          <div className="text-[11px] text-slate-400 mt-1.5 flex gap-3 flex-wrap">
            <span className="flex items-center gap-1"><CalendarDays className="w-3 h-3" /> {dateRange(ev.starts_at, ev.ends_at)}</span>
            {(ev.venue || ev.city) && <span className="flex items-center gap-1"><MapPin className="w-3 h-3" /> {[ev.venue, ev.booth && `Booth ${ev.booth}`, ev.city].filter(Boolean).join(" · ")}</span>}
            <span className="flex items-center gap-1"><Printer className="w-3 h-3" /> {s.print_runs || 0} print run{s.print_runs === 1 ? "" : "s"}</span>
            {(ev.staff || []).length > 0 && <span>{ev.staff.length} booth staff</span>}
          </div>
          <div className="mt-2 flex gap-4 flex-wrap" data-testid={`event-stats-${ev.id}`}>
            <Stat label="Codes" value={s.live || 0} />
            <Stat label="Scanned" value={s.scanned || 0} />
            <Stat label="Claimed" value={`${s.claimed || 0} · ${pct(s.claim_rate)}`} />
            <Stat label="Redeemed" value={`${s.redeemed || 0} · ${pct(s.redeem_rate)}`} />
            <Stat label="Value redeemed" value={usd(s.redeemed_value)} accent />
          </div>
        </div>
        <div className="flex gap-2 shrink-0">
          <Btn variant="secondary" onClick={() => onOpen(ev)} data-testid={`open-event-btn-${ev.id}`}>
            <ScanLine className="w-4 h-4" /> Manage & print <ArrowRight className="w-3.5 h-3.5" />
          </Btn>
        </div>
      </div>
    </Card>
  );
};
